import React from "react";
import CenteringTool from "./components/CenteringTool"; // ✅ fixed path

/**
 * Standalone page; no submission required.
 * Reads ?img=<url> optionally to preload an image.
 */
export default function CenteringToolPage() {
  const params = new URLSearchParams(window.location.search);
  const initialImageUrl = params.get("img") || "";

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert(`Copied: ${text}`);
    } catch {
      alert(text);
    }
  };

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <CenteringTool
        initialImageUrl={initialImageUrl}
        onUse={({ lPct, rPct, tPct, bPct }) => {
          // Copy both sets so the grader can paste into the form
          copy(`L|R: ${lPct}% | ${rPct}%, T|B: ${tPct}% | ${bPct}%`);
        }}
      />
    </div>
  );
}
